export const projects = [
  {
    title: 'Parc national du Teide',
    description:
      "Le parc national du Teide est un site classé au patrimoine mondial de l'UNESCO situé à Tenerife, en Espagne.",
    src: '01.webp',
    link: '#',
    color: '#d64045ff',
  },
  {
    title: 'Roque Nublo',
    description:
      'Roque Nublo est une formation rocheuse importante à Gran Canaria, en Espagne.',
    src: '02.webp',
    link: '#',
    color: '#3B82F6',
  },
  {
    title: 'Parc national de Garajonay',
    description:
      'Le parc national de Garajonay est une zone forestière luxuriante à La Gomera, en Espagne.',
    src: '06.webp',
    link: '#',
    color: '#FA6E58',
  },
  {
    title: 'Dunes de Maspalomas',
    description:
      'Les dunes de Maspalomas sont une réserve naturelle à Gran Canaria, en Espagne.',
    src: '04.webp',
    link: '#',
    color: '#467599ff',
  },
  {
    title: 'Cueva de los Verdes',
    description:
      'La Cueva de los Verdes est un tube de lave et une attraction touristique à Lanzarote, en Espagne.',
    src: '05.webp',
    link: '#',
    color: '#1d3354ff',
  },
  {
    title: 'Parc national de Timanfaya',
    description:
      'Le parc national de Timanfaya est un parc volcanique à Lanzarote, en Espagne.',
    src: '06.webp',
    link: '#',
    color: '#324664ff',
  },
];
